import React from 'react';

function Categories({ tags = [], title = "", description = "", taglines = "", mainContainerClass = "", isStaticRadius = false, radiusType = "rounded-tr-md" }) {

    return (
        <section className={`w-full bg-gradient-radial py-5 lg:py-5 ${mainContainerClass || ""}`}>
            <div className="container mx-auto px-4 lg:px-24">
                <div className='w-full flex flex-col items-center gap-6 mb-4'>
                    {
                        !!title &&
                        (
                            <h2
                                className="text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center sm:text-center">
                                {title}
                            </h2>
                        )
                    }
                    {
                        !!taglines && (
                            <p className="text-sm text-center sm:text-base lg:text-xl font-urbanist text-stone-300" dangerouslySetInnerHTML={{ __html: taglines }}>
                            </p>
                        )
                    }
                    {
                        !!description && (
                            <div className='bg-white shadow-[0px_0px_5px_5px_rgba(171,198,248,0.5)] transition-shadow px-8 py-1 rounded-full text-neutral-950 font-semibold font-inter text-sm sm:text-md lg:text-2xl italic leading-6 lg:leading-10'>
                                {description}
                            </div>
                        )
                    }
                </div>
                <div className="flex flex-row flex-wrap justify-center items-center gap-3 md:gap-6 p-2 mx-auto">
                    {
                        tags.map((catName, index) => {
                            const radiusClass = !isStaticRadius ? (index % 2 === 1 ? 'rounded-tr-md' : 'rounded-tl-md') : (radiusType || "rounded-tr-md");
                            return (
                                <div
                                    key={index}
                                    className={`flex flex-col items-center bg-gradient-radial px-2 md:px-5 py-1 sm:py-2 md:py-3 rounded-3xl ${radiusClass} border border-white transition-transform hover:scale-105`}
                                >
                                    <h3 className="text-white text-[0.53rem] sm:text-[1.17rem] font-semibold font-poppins leading-normal">
                                        {catName}
                                    </h3>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default Categories